import { sortMatchChoices } from '@/lib/util';
import { useCreateChoiceMutation } from '@/modules/services';
import { Choice, ChoiceMetadataType } from '@/modules/types/choice';
import { QuizQuestion } from '@/modules/types/question';
import { AddIcon, Button, Col, Row } from 'elmo-elements';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import MatchGroup from './components/matchGroup';

export const MatchChoice = (): React.ReactElement => {
  const { control, getValues, clearErrors } = useFormContext<QuizQuestion>();

  const {
    remove,
    fields: choicesFields,
    replace,
    insert,
  } = useFieldArray({
    name: 'choices',
    control,
  });
  const [_createChoice, createChoiceStatus] = useCreateChoiceMutation();

  const revalidatePosition = () => {
    const sortedChoices = sortMatchChoices(
      getValues('choices') || choicesFields,
    );

    replace(sortedChoices);
  };
  const addChoice = () => {
    clearErrors();
    const position = choicesFields.filter(
      (choice) => choice.type === ChoiceMetadataType.main,
    ).length;

    insert(position * 2, {
      content: '',
      position,
      isCorrect: false,
      type: ChoiceMetadataType.main,
    });
    insert(position * 2 + 1, {
      content: '',
      position,
      isCorrect: false,
      type: ChoiceMetadataType.secondary,
    });
  };

  const removeChoice = (item: Choice, target: Choice) => {
    const itemFieldIndex = choicesFields.findIndex(
      (choiceField) => choiceField.id === item.id,
    );

    remove(itemFieldIndex);
    remove(itemFieldIndex);

    revalidatePosition();
  };

  return (
    <Row wrap="wrap">
      <Col xs={24}>
        <MatchGroup
          choices={choicesFields || getValues('choices')}
          hasDelete
          onDelete={removeChoice}
        />
      </Col>
      <Col xs={24}>
        <Button
          ariaLabel="Save Choice"
          onClick={() => {
            addChoice();
          }}
          isLoading={createChoiceStatus.isLoading}
          icon={<AddIcon />}
          isUppercase={false}
        >
          Add choice
        </Button>
      </Col>
    </Row>
  );
};
